import { Link } from "react-router-dom";
import { fyaiStats } from "@/mocks/fyai-data";

export default function FyaiHighlights() {
  return (
    <section className="w-full bg-background-100 px-4 py-16 md:px-6 md:py-20">
      <div className="overflow-hidden rounded-[1.75rem] bg-primary-950 px-6 py-10 md:px-12 md:py-14">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.9fr_1.6fr] lg:items-center lg:gap-14">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-primary-900/60 px-3 py-1.5 text-xs font-medium text-accent-300">
              <i className="ri-heart-3-fill text-secondary-400" />
              陪伴数据
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-background-50 md:text-3xl">
              被千万人选择的陪伴
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-primary-200 md:text-base">
              从上线至今，风月AI陪伴用户度过无数个夜晚，稳定的服务让每一次倾诉都不会掉线。
            </p>
            <Link
              to="/download"
              className="mt-6 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-600"
            >
              <i className="ri-download-2-line" />
              风月AI官网下载
            </Link>
          </div>

          <div className="grid grid-cols-2 gap-x-6 gap-y-8 sm:grid-cols-4">
            {fyaiStats.map((stat) => (
              <div key={stat.label}>
                <p className="font-heading text-3xl font-black text-accent-400 md:text-4xl">
                  {stat.value}
                </p>
                <span className="mt-3 block h-0.5 w-8 bg-primary-500" />
                <p className="mt-3 text-xs text-primary-200 md:text-sm">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}